import React from 'react';
import StarRatings from 'react-star-ratings';

export default function Rating(props)
{
    var count = props.rating;
    
    if (isNaN(count) || !count)
        count = 2; //Star with minimum 2 star
    
    return (<StarRatings
        rating={count}
        starRatedColor="var(--colors-primary)"
        starEmptyColor="#A8A8A8"
        starDimension="18px"
        starSpacing="0px"
        />);
    ;
}